import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CompanyMembership } from 'src/app/core/companies.service';
import { NavigationService } from 'src/app/core/navigation.service';
import { STORE_DETAILS_TEAM_TABLE_COLUMNS } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-company-details-team-data-table',
  templateUrl: './company-details-team-data-table.component.html',
  styleUrls: ['./company-details-team-data-table.component.scss'],
})
export class CompanyDetailsTeamDataTableComponent {
  @Input() company_membership: CompanyMembership[] = [];
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();
  displayed_columns: string[] = STORE_DETAILS_TEAM_TABLE_COLUMNS;

  constructor(private navigation_service: NavigationService) {}

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }

  getFullName(seller: CompanyMembership): string {
    return `${seller.seller_firstname} ${seller.seller_lastname}`;
  }

  onSellerDetailClick(seller_id: string) {
    this.navigation_service.toSellerDetails(seller_id);
  }
}
